import React from 'react';
import Loadable from 'components/Loadable';
import {PrivateLayout} from 'components/Layouts';

import renderRoutes from 'pages/routes';

export default {
  exact: false,
  auth: true,
  path: '/attendance',
  component: ({routes}) => {
    return <PrivateLayout>{renderRoutes(routes)}</PrivateLayout>;
  },
  routes: [
    {
      exact: true,
      auth: true,
      path: '/attendance',
      component: Loadable({
        loader: () => import('./lists'),
      }),
    },
  ],
};



// WEBPACK FOOTER //
// ./src/pages/back/attendance/index.js